// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#007B7F', // Teal color
    },
    secondary: {
      main: '#FF9800', // Bright orange color
    },
    error: {
      main: '#FF5252', // Pink/Red for error or alerts
    },
    background: {
      default: '#E0F7FA', // Light teal/pastel blue for the background
    },
    text: {
      primary: '#212121', // Dark grey for contrast
      secondary: '#FFFFFF', // White for accent text
    },
  },
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#007B7F', // Set the color for the unselected radio button
          '&.Mui-checked': {
            color: '#FF9800', // Set the color for the selected radio button
          },
        },
      },
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      color: '#FF9800', // Heading color - secondary (orange)
    },
    body1: {
      color: '#007B7F', // Main body text in primary (teal)
    },
  },
});

export default theme;
